var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('img',{attrs:{"src":_vm.image,"alt":"name","id":"image"}}),_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('b-icon',{staticClass:"icon",attrs:{"icon":"x-circle-fill"},on:{"click":_vm.remove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }